var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { bus: _vm.busModal, "max-width": "700px" },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("v-spacer"),
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "BaseButton",
                { attrs: { dark: "" }, on: { click: _vm.openSearchShort } },
                [_vm._v(" Procurar ativo ")]
              ),
              _c(
                "BaseButton",
                {
                  attrs: { primary: "", loading: _vm.loading },
                  on: { click: _vm.enviar }
                },
                [_vm._v(" Trocar ativo ")]
              ),
              _c("v-spacer")
            ]
          }
        }
      ])
    },
    [
      _c("Title", {
        attrs: {
          title: "Faça a troca do ativo",
          subtitle: "Preencha abaixo para concluir"
        }
      }),
      _c(
        "v-form",
        {
          ref: "form",
          staticClass: "row",
          on: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c("div", { staticClass: "col-12" }, [
            _c("h2", { staticClass: "subhead" }, [_vm._v("Ativo atual")]),
            _c(
              "div",
              { staticClass: "row" },
              [
                _c("v-text-field", {
                  staticClass: "col-8",
                  attrs: { label: "Nome do ativo", readonly: "" },
                  model: {
                    value: _vm.ativoOld.nome_ativo,
                    callback: function($$v) {
                      _vm.$set(_vm.ativoOld, "nome_ativo", $$v)
                    },
                    expression: "ativoOld.nome_ativo"
                  }
                }),
                _c("v-text-field", {
                  staticClass: "col-4",
                  attrs: {
                    label: "P/L sugerido",
                    value: "R$ 0,00",
                    readonly: ""
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "col-12" }, [
            _c("h2", { staticClass: "subhead" }, [_vm._v("Novo ativo")]),
            _c(
              "div",
              { staticClass: "row" },
              [
                _c("v-text-field", {
                  staticClass: "col-8",
                  attrs: {
                    label: "Nome do ativo*",
                    required: "",
                    rules: [_vm.rules.required]
                  },
                  model: {
                    value: _vm.ativoNew.nome_ativo,
                    callback: function($$v) {
                      _vm.$set(_vm.ativoNew, "nome_ativo", $$v)
                    },
                    expression: "ativoNew.nome_ativo"
                  }
                }),
                _c("v-currency-field", {
                  ref: "edit-valor",
                  staticClass: "col-4",
                  attrs: {
                    prefix: "R$ ",
                    label: "P/L sugerido*",
                    required: "",
                    rules: [_vm.rules.required, _vm.rules.positive]
                  },
                  model: {
                    value: _vm.ativoNew.pl,
                    callback: function($$v) {
                      _vm.$set(_vm.ativoNew, "pl", $$v)
                    },
                    expression: "ativoNew.pl"
                  }
                })
              ],
              1
            )
          ])
        ]
      ),
      _c("AtivoShort", {
        attrs: {
          bus: _vm.busModal,
          "only-one": "",
          "pl-total": _vm.plTotal,
          "pl-sugerido": _vm.getNumber(_vm.ativoNew.pl),
          fixados: _vm.fixados
        }
      }),
      _c("AtivoLong", {
        attrs: {
          bus: _vm.busModal,
          "only-one": "",
          "pl-total": _vm.plTotal,
          "pl-sugerido": _vm.getNumber(_vm.ativoNew.pl),
          fixados: _vm.fixados
        }
      }),
      _c("EditarAtivo", {
        attrs: { bus: _vm.busModal, "only-one": "", "pl-total": _vm.plTotal }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }